import React from 'react'
import { Link } from 'react-router-dom'
import WhatsApp from '../../assets/images/WhatsApp.png'
import FooterLogo from '../../assets/images/800home/Logo.webp'
import {
    Envelope,
    Facebook,
    GeoAlt,
    Instagram,
    Linkedin,
    Phone,
    Telephone,
    Tiktok,
    Whatsapp,
    Youtube,
} from 'react-bootstrap-icons'

// Sources

const Footer = () => {
    return (
        <>
            <section id="website-responsive" className="container-fluid bg-footer py-5 mt-2 mt-md-0">
                <div className="row justify-content-center align-items-start py-md-4 gy-4">
                    <div className="col-11 col-lg-3 text-start pb-4 pb-md-0">
                        <div className="col-12 mx-auto">
                            <div className="pb-2 pb-md-4 text-center text-md-start">
                                <img className="footer-logo" src={FooterLogo} alt="Footer Logo" title="Footer Logo" />
                            </div>
                            <div className="text-white fs-ss-16 pb-2 pb-md-4 fw-300 col-11 col-md-9 text-start">
                                Discover prime investment opportunities in Dubai with 800 Homes – Where your real estate
                                journey begins.
                            </div>
                            <div id="social-media" className="pt-2 pt-md-0">
                                <div className="text-ss-secondary fs-ss-22 text-white">
                                    <a
                                        href="https://www.facebook.com/800Homes"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    >
                                        {' '}
                                        <Facebook className="me-3" />{' '}
                                    </a>
                                    <a
                                        href="https://www.instagram.com/800homesae/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    >
                                        {' '}
                                        <Instagram className="me-3" />{' '}
                                    </a>
                                    <a
                                        href="https://www.tiktok.com/@800homes"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    >
                                        {' '}
                                        <Tiktok className="me-3" />{' '}
                                    </a>
                                    <a
                                        href="https://www.linkedin.com/company/800-homes-real-estate-brokerage-firm/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    >
                                        {' '}
                                        <Linkedin className="me-3" />{' '}
                                    </a>
                                    <a
                                        href="https://www.youtube.com/@800homesRE"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    >
                                        {' '}
                                        <Youtube className="me-3" />{' '}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-5 col-lg-2 mt-md-5">
                        <div className="text-ss-secondary fs-ss-22 fw-500 text-white text-uppercase"> Quick Links </div>
                        <div className="text-white fs-ss-16 pt-2 pt-md-3">
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/properties-for-sale/"
                                >
                                    {' '}
                                    All Properties{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/properties-for-sale?tab=apartments"
                                >
                                    {' '}
                                    Apartments{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/properties-for-sale?tab=penthouses"
                                >
                                    {' '}
                                    Penthouses{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/properties-for-sale?tab=townhouses"
                                >
                                    {' '}
                                    Townhouses{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/properties-for-sale?tab=villas"
                                >
                                    {' '}
                                    Villas{' '}
                                </Link>{' '}
                            </div>

                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/events/"
                                >
                                    {' '}
                                    Events{' '}
                                </Link>{' '}
                            </div>

                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/careers/"
                                >
                                    {' '}
                                    Careers{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/dubai-property-investment/"
                                >
                                    {' '}
                                    Property Investment{' '}
                                </Link>{' '}
                            </div>
                        </div>
                    </div>

                    <div className="col-6 col-lg-2 mt-md-5">
                        <div className="text-ss-secondary fs-ss-22 fw-500 text-white text-uppercase overflow-hidden2">
                            Quick Links
                        </div>
                        <div className="text-white fs-ss-16 pt-2 pt-md-3">
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/our-team/"
                                >
                                    {' '}
                                    Our Team{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/brochures/"
                                >
                                    {' '}
                                    Brochures{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/reports/"
                                >
                                    {' '}
                                    Reports{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/faqs/"
                                >
                                    {' '}
                                    FAQs{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/news/"
                                >
                                    {' '}
                                    News{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/mortgage-calculator/"
                                >
                                    {' '}
                                    Mortgage Calculator{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/privacy-policy/"
                                >
                                    {' '}
                                    Privacy Policy{' '}
                                </Link>{' '}
                            </div>
                            <div className="mb-1 mb-md-2">
                                {' '}
                                <Link
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    to="/terms-and-conditions/"
                                >
                                    {' '}
                                    Terms & Conditions{' '}
                                </Link>{' '}
                            </div>
                        </div>
                    </div>

                    <div className="col-11 col-lg-3 mt-md-5">
                        <div className="text-ss-secondary fs-ss-22 fw-500 text-white text-uppercase">Contact Us</div>
                        <div className="pt-2 pt-md-3">
                            <div className="pb-2">
                                <a
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    href="tel:80046637"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {' '}
                                    <Telephone className="text-ss-primary me-2" /> 80046637{' '}
                                </a>
                            </div>
                            <div className="pb-2">
                                <a
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    href="tel:+971585746637"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {' '}
                                    <Phone className="text-ss-primary me-2" /> +971-58-574-6637{' '}
                                </a>
                            </div>
                            <div className="pb-2">
                                <a
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    href="https://api.whatsapp.com/send/?phone=971585746637&text&type=phone_number&app_absent=0"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {' '}
                                    <Whatsapp className="text-ss-primary me-2" /> +971-58-574-6637{' '}
                                </a>
                            </div>
                            <div className="pb-2">
                                <a
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                    href="mailto:inquiry@800homes.ae"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {' '}
                                    <Envelope className="text-ss-primary me-2" /> inquiry@800homes.ae{' '}
                                </a>
                            </div>

                            <div className="pb-2 text-white text-hover-ss-primary fw-300">
                                <GeoAlt className="text-ss-primary me-2" />
                                <a
                                    href="https://www.google.com/maps/place/800Homes+Real+Estate+Brokerage+LLC/@25.041544,55.1162041,17z/data=!3m1!4b1!4m6!3m5!1s0x3e5f13b09fd3f0b5:0xd6f8b83178154e03!8m2!3d25.041544!4d55.1162041!16s%2Fg%2F11wmt11z16"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-decoration-none text-white text-hover-ss-primary fw-300"
                                >
                                    Office 909A, 9th Floor, Ibn Batuta Gate Offices Building, Jebel Ali, Dubai
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="container-fluid bg-white fs-ss-14 text-black text-center lh-sm py-2">
                Copyright © 2026 - 800 Homes | Developed by{' '}
                <a
                    href="https://simplesolutionz.org"
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none text-black"
                >
                    {' '}
                    Simple Solutionz{' '}
                </a>
            </section>

            <div className="">
                <div className="d-none d-md-block">
                    <a
                        className=""
                        href="https://web.whatsapp.com/send?phone=971585746637&text="
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src={WhatsApp}
                            className="w-icons position-fixed z-top"
                            alt="Chat with 800 Homes on WhatsApp" title="Chat with 800 Homes on WhatsApp"
                            style={{ bottom: '20px', right: '20px', fontSize: '48px' }}
                        />
                    </a>
                </div>

                <div className="d-block d-md-none">
                    <a
                        className=""
                        href="https://api.whatsapp.com/send?phone=971585746637&text="
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src={WhatsApp}
                            className="w-icons position-fixed z-top"
                            alt="Chat with 800 Homes on WhatsApp" title="Chat with 800 Homes on WhatsApp"
                            style={{ bottom: '20px', right: '20px', fontSize: '48px' }}
                        />
                    </a>
                </div>
            </div>
        </>
    )
}

export default Footer

